import { DateTime } from "luxon";

import type { Calendar } from "../Models/Domain";
import { CALENDAR_TYPE } from "../Models/Common";

import useCalendarsStore from "../Store";

import { hasValue } from "@/Utils/Objects";

const FilterByPatientActionHandler = (patientUuid: string): void => {
  const calendarsStore = useCalendarsStore();

  const now = DateTime.now();
  const patient = calendarsStore.patientsMap.get(patientUuid);

  if (!hasValue(patient)) return;

  const calendar: Calendar = {
    uuid: now.toUnixInteger().toString(),
    createdAt: now.toUnixInteger(),
    type: CALENDAR_TYPE.FILTER,
    name: patient.username,
    description: patient.username,
    backgroundColor: "#f7bec3",
    foregroundColor: "#212121",
    timeZone: now.zoneName!,
    canOverlap: true,
    duration: null,
    isEnabled: true,
    isDefault: false,
    originCalendarUuid: undefined,
  };

  calendarsStore.events = calendarsStore.events.map((e) => {
    if (e.patientUuid === patientUuid) {
      calendar.originCalendarUuid = e.calendarUuid;

      return { ...e, calendarUuid: calendar.uuid };
    }

    return e;
  });
  calendarsStore.calendars.push(calendar);
};

export default FilterByPatientActionHandler;
